import { render, staticRenderFns } from "./DesktopPage.vue?vue&type=template&id=815c0ca0&scoped=true&"
import script from "./DesktopPage.vue?vue&type=script&lang=js&"
export * from "./DesktopPage.vue?vue&type=script&lang=js&"
import style0 from "./DesktopPage.vue?vue&type=style&index=0&id=815c0ca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815c0ca0",
  null
  
)

export default component.exports